import requestInstance from '../../../../utils/instance-utils';

export const getAllAssignmentsById = (clientId: number, userId: number) =>
    requestInstance.get(`/assignments?clientId=${clientId}&userId=${userId}`);

export const getPendingAssignment = (assignmentId?: number) =>
    requestInstance.get(
        `assignment${assignmentId ? `?assignmentId=${assignmentId}` : ''}`
    );

export const getAllUserAssignmentCoursesById = (
    userId: number,
    clientId: number,
    userAssignmentId: number,
    isAutoAssigned = false
) =>
    requestInstance.get(
        `assignment/course-details/${userId}/${clientId}/${userAssignmentId}?isAutoAssigned=${isAutoAssigned}`
    );
